import { fetcher } from 'src/config/request';
import { ModuleActionEndpoints } from './endpoints';
export const ModuleActionsService = {
    renameModule(moduleId, name) {
        return fetcher.put(ModuleActionEndpoints.renameModule(moduleId), { name });
    },
    reorderModule({ moduleId, targetModuleOrderId }) {
        return fetcher.post(ModuleActionEndpoints.reorderModule(moduleId), { targetModuleOrderId });
    },
    duplicateModule(payload) {
        return fetcher.post(ModuleActionEndpoints.duplicateModule(), payload);
    }
};
